



import { useParams } from "react-router-dom";
import TasksBoard from '../../components/Tasks/TaskBoard'

export default function TasksPage() {
  const { view } = useParams(); // my | all | team

  return (
    <div className="h-full w-full">
      <TasksBoard view={view || "my"} />
    </div>
  );
}
// import { useParams } from "react-router-dom";
// import TasksBoard from "../../components/Tasks/TaskBoard";

// export default function TasksPage() {
//   const { view } = useParams(); // my | all | team

//   const user = JSON.parse(localStorage.getItem("user"));
//   const roleId = Number(user?.role_id);
//   const isAdmin = roleId === 2;

//   // 🔐 Prevent normal user from accessing "all"
//   let safeView = view || "my";

//   if (!isAdmin && safeView === "all") {
//     safeView = "my";   // 👈 FORCE USER TO MY TASKS
//   }

//   return (
//     <div className="h-full w-full">
//       <TasksBoard view={safeView} />
//     </div>
//   );
// }
